import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roullet',
  templateUrl: './roullet.component.html',
  styleUrls: ['./roullet.component.css']
})
export class RoulletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/roullet/roullet.component.ts